import type { DSNCPre } from 'shared-definitions/types'
import type { ApiComponentPre } from 'data-source/types.wp'
import { htmlMapper } from 'data-source/mappers/htmlMapper'

export function ncPre(input: ApiComponentPre): DSNCPre {
  return {
    resource: 'nc-pre',
    bodyHtml: htmlMapper(input.body),
  }
}
